(() => {
  const root = document.querySelector('[data-gk-filters]');
  const form = document.querySelector('[data-gk-filter-form]');
  const sort = document.querySelector('[data-gk-sort]');
  const desktop = window.matchMedia('(min-width: 1024px)');

  if (sort) {
    sort.addEventListener('change', () => {
      if (form) {
        form.requestSubmit();
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url);
      }
    });
  }

  const sortSheet = document.querySelector('[data-gk-sortsheet]');
  const actionBar = document.querySelector('[data-gk-actionbar]');

  // Fixed UI is moved to <body> so the page's stacking contexts can never cover it.
  [actionBar, sortSheet].forEach((el) => el && document.body.appendChild(el));

  const setSortOpen = (open) => {
    if (!sortSheet) return;
    sortSheet.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('gk-scroll-lock', open);
  };

  if (sortSheet) {
    document.querySelectorAll('[data-gk-sheet-open="sort"]').forEach((el) => el.addEventListener('click', () => setSortOpen(true)));
    sortSheet.querySelectorAll('[data-gk-sheet-close]').forEach((el) => el.addEventListener('click', () => setSortOpen(false)));
    sortSheet.querySelectorAll('[data-gk-sort-value]').forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-gk-sort-value');
        setSortOpen(false);
        if (sort && sort.value === value) return;
        if (sort) {
          sort.value = value;
          sort.dispatchEvent(new Event('change'));
        } else {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          window.location.assign(url);
        }
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setSortOpen(false);
    });
  }

  if (!root || !form) return;

  const openers = document.querySelectorAll('[data-gk-filters-open]');
  const closers = root.querySelectorAll('[data-gk-filters-close]');

  // The page content sits in a stacking context below the fixed bottom bar, so on small screens
  // the filter sheet is moved to <body> to make sure its buttons are never covered.
  const marker = document.createComment('gk-filters');
  const mobile = window.matchMedia('(max-width: 1023px)');
  const place = () => {
    if (mobile.matches && root.parentNode !== document.body) {
      root.parentNode.insertBefore(marker, root);
      document.body.appendChild(root);
    } else if (!mobile.matches && marker.parentNode) {
      marker.parentNode.insertBefore(root, marker);
      marker.remove();
    }
  };
  place();
  mobile.addEventListener('change', place);

  const setOpen = (open) => {
    root.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('gk-scroll-lock', open);
    openers.forEach((el) => el.setAttribute('aria-expanded', String(open)));
  };

  openers.forEach((el) => el.addEventListener('click', () => setOpen(true)));
  closers.forEach((el) => el.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });
  desktop.addEventListener('change', (event) => {
    if (event.matches) setOpen(false);
  });

  // On desktop results update as filters change; on mobile the Show results button applies them.
  let timer;
  form.addEventListener('change', (event) => {
    if (!desktop.matches || event.target === sort) return;
    clearTimeout(timer);
    timer = setTimeout(() => form.requestSubmit(), 350);
  });

  form.addEventListener('submit', () => {
    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === '') input.disabled = true;
    });
  });
})();
